
export class EInvoiceUomModel {
    fiItemHdrGuid: string;
    fiItemLineGuid: string;               
    baseUOM:string;
    uom: string;
    uomBaseRatio: number;
    isBaseUom: boolean;
    einvoiceUomDesc: string;
}